import cookie from 'js-cookie';

const ACTIVE_ORG_ID_LS_KEY = '__sb_active_org_id__';
const LAST_PROTOCOL_WARNING_TIME_KEY = '__sb_last_protocol_warning_time__';
const META_SID_KEY = '__sb_meta_sid__';
const AUTHENTICATION_TOKEN_LS_KEY = '__sb_authentication_token__';
const AUTHENTICATION_COOKIE_KEY = '__sbauth'; // Shorter for limited cookie size

export const setStoredActiveOrgId = (id: number | null) => {
  if (id) {
    localStorage.setItem(ACTIVE_ORG_ID_LS_KEY, id.toString());
    sessionStorage.setItem(ACTIVE_ORG_ID_LS_KEY, id.toString());
  } else {
    localStorage.removeItem(ACTIVE_ORG_ID_LS_KEY);
    sessionStorage.removeItem(ACTIVE_ORG_ID_LS_KEY);
  }
};

export const getStoredActiveOrgId = (): number | null => {
  // Prefer session storage first, to maintain the tab's activeOrgId if you have multiple
  let storedId = sessionStorage.getItem(ACTIVE_ORG_ID_LS_KEY);
  if (!storedId) {
    storedId = localStorage.getItem(ACTIVE_ORG_ID_LS_KEY);
  }
  return storedId ? parseInt(storedId, 10) || null : null;
};

export const setStoredAuthenticationToken = (token: string | null) => {
  if (token) {
    localStorage.setItem(AUTHENTICATION_TOKEN_LS_KEY, token);
    cookie.set(AUTHENTICATION_COOKIE_KEY, token, {
      expires: new Date(2147483647 * 1000), // Browser compatible maximum date
      secure: window.location.protocol === 'https:',
      sameSite: 'strict',
    });
  } else {
    localStorage.removeItem(AUTHENTICATION_TOKEN_LS_KEY);
    cookie.remove(AUTHENTICATION_COOKIE_KEY, { expires: 1 });
  }
};

export const getStoredAuthenticationToken = (): string | null => {
  return (
    localStorage.getItem(AUTHENTICATION_TOKEN_LS_KEY) ||
    cookie.get(AUTHENTICATION_COOKIE_KEY) ||
    null
  );
};

export const setStoredLastProtocolWarningTime = (time: number) => {
  if (time) {
    localStorage.setItem(LAST_PROTOCOL_WARNING_TIME_KEY, time.toString());
  } else {
    localStorage.removeItem(LAST_PROTOCOL_WARNING_TIME_KEY);
  }
};

export const getStoredLastProtocolWarningTime = () => {
  return parseInt(localStorage.getItem(LAST_PROTOCOL_WARNING_TIME_KEY) || '0');
};

export const setStoredSocketMetaSid = (metaSid: string | null) => {
  if (metaSid) {
    sessionStorage.setItem(META_SID_KEY, metaSid);
  } else {
    sessionStorage.removeItem(META_SID_KEY);
  }
};

export const getStoredSocketMetaSid = (): string | null => {
  return sessionStorage.getItem(META_SID_KEY) || null;
};
